export class CovenantGroupParams {
    productId?: any;
    financialId?: any;
    id?:number|null;
}
